import { ServiceBase, Result, PagedResult, convertStringsToDateTimes } from "./ServiceBase";
import { UserELP, DateFields } from "../models/UserELP";
import { UserELPUsers } from "../models/UserELPUsers";

const preProcessDates = (input: UserELP[]) => {
    return input.map(x => convertStringsToDateTimes(x, DateFields));
}
export default class UserELPService extends ServiceBase {

    public static async get(): Promise<Result<UserELP>> {

        var result = await this.requestJson<UserELP>({
            url: `api/UserELP/get/`,
            method: "GET"
        });

        return result;
    }

    public static async getELP(id: string): Promise<Result<UserELP>> {

        var result = await this.requestJson<UserELP>({
            url: `api/UserELP/get/${id}`,
            method: "GET"
        });

        return result;
    }

    public static async save(model: UserELP): Promise<Result<UserELP>> {

        //console.log('saving:', model);

        var result = await this.requestJson<UserELP>({
            url: `api/UserELP/save`,
            method: "POST",
            data: model
        });

        return result;
    }

    public static async list(): Promise<Result<PagedResult<UserELP>>> {

        var result = await this.requestJson<PagedResult<UserELP>>({
            url: `api/UserELP/list`,
            method: "GET",
        });

        return result;
    }

    public static async listAll(sortOrder?: string): Promise<Result<PagedResult<UserELPUsers>>> {

        var result = await this.requestJson<PagedResult<UserELPUsers>>({
            url: `api/UserELP/listall?sortorder=` + sortOrder,
            method: "GET",
        });

        return result;
    }
}